<template>
  <section class="verdeOscuro">
    <v-container id="eko" class="py-15 fill-height">
      <v-row justify="center" align="center" class="py-5">
        <v-col align="center" cols="10" md="5" class="ma-auto">
          <div v-scrollanimation class=" abajo">
            <v-img src="@/assets/vect/hoja.svg" width="100" class="mb-5">
            </v-img>
            <h1 class="text-center white--text font-weight-bold">
              {{ $t("eko.titulo") }}
            </h1>
          </div>
          <div v-scrollanimation class="hr accent mx-auto my-5"></div>
          <p v-scrollanimation class="anim white--text">
            {{ $t("eko.texto") }}
          </p>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "receta",
  data: () => ({
    isActive: false,
  }),
};
</script>

<style scoped>
#eko {
   min-height: 100vh;
 }

</style>